import { FIELD_TYPES } from './settings.constants';

const mainStructureOptions = [
  { value: '111', label: '111' },
  { value: '121', label: '121' },
  { value: '211', label: '211' },
  { value: '221', label: '221' },
  { value: '111-211', label: '111-211' },
  { value: '121-221', label: '121-221' },
  { value: '211-111', label: '211-111' },
  { value: '221-121', label: '221-121' },
  { value: '311', label: '311' },
  { value: '312', label: '312' },
  { value: '315', label: '315' },
  { value: '321', label: '321' },
  { value: '311-312', label: '311-312' },
  { value: '312-311', label: '312-311' }
];
const yesNoOptions = [
  { value: true, label: 'Ja' },
  { value: false, label: 'Nee' }
];

export const SCHOOL_OPTIONS = {
  languageSystem: [{ value: 'Nederlandstalig', label: 'Nederlandstalig' }],
  clb: [
    { value: '114215', label: '114215' },
    { value: '114256', label: '114256' },
    { value: '114272', label: '114272' },
    { value: '114512', label: '114512' },
    { value: '114785', label: '114785' },
    { value: '114942', label: '114942' },
    { value: '115014', label: '115014' }
  ],
  mainStructure: mainStructureOptions,
  secondaryStructure: mainStructureOptions,
  status: [
    { value: 'E', label: 'E' },
    { value: 'S', label: 'S' }
  ],
  type: [
    { value: 'Autonome kleuterschool', label: 'Autonome kleuterschool' },
    {
      value: 'Autonome kleuterschool voor buitengewoon onderwijs',
      label: 'Autonome kleuterschool voor buitengewoon onderwijs'
    },
    { value: 'Autonome lagere school', label: 'Autonome lagere school' },
    {
      value: 'Autonome lagere school voor buitengewoon onderwijs',
      label: 'Autonome lagere school voor buitengewoon onderwijs'
    },
    { value: 'Basisschool', label: 'Basisschool' },
    { value: 'Basisschool voor buitengewoon onderwijs', label: 'Basisschool voor buitengewoon onderwijs' },
    { value: 'Centrum voor deeltijds onderwijs', label: 'Centrum voor deeltijds onderwijs' },
    { value: 'School voor buitengewoon secundair onderwijs', label: 'School voor buitengewoon secundair onderwijs' },
    {
      value: 'School voor voltijds gewoon secundair onderwijs',
      label: 'School voor voltijds gewoon secundair onderwijs'
    },
    {
      value: 'School voor voltijds gewoon secundair onderwijs en deeltijds beroepsonderwijs',
      label: 'School voor voltijds gewoon secundair onderwijs en deeltijds beroepsonderwijs'
    },
    { value: 'Syntra', label: 'Syntra' }
  ],
  exceptionalEducation: yesNoOptions,
  offersPartTime: yesNoOptions,
  offersFullTime: yesNoOptions
};

export const SCHOOL_FIELDS = [
  { field: 'name', label: 'Naam', defaultValue: '', required: true },
  { field: 'fullName', label: 'Volledige Naam', defaultValue: '', required: true },
  { field: 'postcode', label: 'Postcode', defaultValue: '' },
  { field: 'district', label: 'Gemeente', defaultValue: '' },
  { field: 'street', label: 'Straatnaam', defaultValue: '' },
  { field: 'houseNumber', label: 'Huisnummer', defaultValue: '' },
  { field: 'province', label: 'Provincie', defaultValue: '' },
  {
    field: 'exceptionalEducation',
    label: 'Buitengewoon Onderwijs',
    type: FIELD_TYPES.SELECT,
    defaultValue: ''
  },
  {
    field: 'offersPartTime',
    label: 'Biedt Deeltijds Aan',
    type: FIELD_TYPES.SELECT,
    defaultValue: ''
  },
  {
    field: 'offersFullTime',
    label: 'Biedt Voltijds Aan',
    type: FIELD_TYPES.SELECT,
    defaultValue: ''
  },
  { field: 'philosophy', label: 'Levensbeschouwing', type: FIELD_TYPES.SELECT, defaultValue: '' },
  {
    field: 'languageSystem',
    label: 'Taalstelsel',
    type: FIELD_TYPES.SELECT,
    defaultValue: SCHOOL_OPTIONS.languageSystem[0].value
  },
  { field: 'educationalProject', label: 'Pedagogisch project', defaultValue: '' },
  { field: 'phone', label: 'Telefoon', defaultValue: '' },
  { field: 'email', label: 'E-mail', defaultValue: '' },
  { field: 'website', label: 'Website', defaultValue: '' },
  { field: 'directorFirstName', label: 'Voornaam Directeur', defaultValue: '' },
  { field: 'directorLastName', label: 'Familienaam Directeur', defaultValue: '' },
  { field: 'clb', label: 'CLB', type: FIELD_TYPES.SELECT, defaultValue: '' },
  { field: 'status', label: 'Status', type: FIELD_TYPES.SELECT, defaultValue: '' },
  { field: 'type', label: 'Type', type: FIELD_TYPES.SELECT, defaultValue: '' },
  { field: 'mainStructure', label: 'Hoofdstructuur 1', type: FIELD_TYPES.SELECT, defaultValue: '' },
  { field: 'secondaryStructure', label: 'Hoofdstructuur 2', type: FIELD_TYPES.SELECT, defaultValue: '' },
  {
    field: 'isVisible',
    label: 'Zichtbaar binnen applicatie',
    type: FIELD_TYPES.SWITCH,
    tip: 'Wanneer dit item niet zichtbaar is binnen deze applicatie dan kan het niet geselecteerd worden op andere schermen.',
    defaultValue: true
  },
  { field: 'remarks', label: 'Algemene opmerkingen', type: FIELD_TYPES.TEXT_AREA, defaultValue: '' }
];

const _createInitialSchoolState = () => {
  const state = {};
  SCHOOL_FIELDS.forEach((f) => {
    state[f.field] = f.defaultValue;
  });
  return state;
};

export const INITIAL_SCHOOL_STATE = _createInitialSchoolState();

export const BRANCH_FIELDS = [
  { field: 'name', label: 'Roepnaam', defaultValue: '', required: true },
  { field: 'postcode', label: 'Postcode', defaultValue: '' },
  { field: 'district', label: 'Gemeente', defaultValue: '' },
  { field: 'street', label: 'Straatnaam', defaultValue: '' },
  { field: 'houseNumber', label: 'Huisnummer', defaultValue: '' },
  { field: 'phone', label: 'Telefoon', defaultValue: '' },
  { field: 'email', label: 'E-mail', defaultValue: '' },
  { field: 'cityDistrict', label: 'Wijk', defaultValue: '' },
  { field: 'cityDistrictManager', label: 'Wijkverantwoordelijke', type: FIELD_TYPES.SELECT, defaultValue: '' },
  {
    field: 'isVisible',
    label: 'Zichtbaar binnen applicatie',
    tip: 'Wanneer dit item niet zichtbaar is binnen deze applicatie dan kan het niet geselecteerd worden op andere schermen.',
    type: FIELD_TYPES.SWITCH,
    defaultValue: true
  },
  { field: 'remarks', label: 'Algemene opmerkingen', type: FIELD_TYPES.TEXT_AREA, defaultValue: '' }
];

const _createInitialBranchState = () => {
  const state = {};
  BRANCH_FIELDS.forEach((f) => {
    state[f.field] = f.defaultValue;
  });
  return state;
};

export const INITIAL_BRANCH_STATE = _createInitialBranchState();

export const GCP_ENTITY_TYPE_TO_TEXT = {
  SchoolNet: 'Schoolnet',
  SchoolManagement: 'Schoolbestuur',
  SchoolCommunity: 'Schoolgemeenschap',
  School: 'School',
  SchoolBranch: 'Vestiging',
  SchoolAgodiBranch: 'AGODI Vestiging'
};
